import React from 'react';
import { BadgeCheckIcon, CalculatorIcon, CalendarXIcon } from 'lucide-react';
import { FinanceOffer } from '../types/catalog';
import { formatDate, isExpired } from '../utils/format';
interface OfferStatusProps {
  offer: FinanceOffer;
  source: 'unidad' | 'marca';
  compact?: boolean;
}
export function OfferStatus({
  offer,
  source,
  compact
}: OfferStatusProps) {
  const expired = isExpired(offer.validUntil);
  const sourceLabel = source === 'unidad' ? 'Condición propia de la unidad' : 'Condición general de la marca';
  if (expired) {
    return <p className="flex items-start gap-1.5 text-xs text-danger" data-id="element-990" data-mp="253wcet1fcnch">
        <CalendarXIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden data-id="element-991" data-mp="2156vwrl3apom" />
        <span data-id="element-992" data-mp="1w63uri88d3lx">Condiciones vencidas el {formatDate(offer.validUntil)} · consultá vigencia</span>
      </p>;
  }
  if (offer.verified) {
    return <p className="flex items-start gap-1.5 text-xs text-ok" data-id="element-993" data-mp="1r8c4esn8hpju">
        <BadgeCheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden data-id="element-994" data-mp="1m8fvcezoj7xf" />
        <span data-id="element-995" data-mp="12tpjh0gglgfw">
          Oferta verificada · vigente hasta {formatDate(offer.validUntil)}
          {!compact && <span className="text-mist" data-id="element-996" data-mp="17kxxk9sqhpze"> · {sourceLabel}</span>}
        </span>
      </p>;
  }
  return <p className="flex items-start gap-1.5 text-xs text-warn" data-id="element-997" data-mp="swulqjs0fk2o">
      <CalculatorIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden data-id="element-998" data-mp="xuw8beona1iw" />
      <span data-id="element-999" data-mp="xss6d2ab3cl9">
        Simulación referencial · condiciones a verificar
        {!compact && <span className="text-mist" data-id="element-1000" data-mp="1ll8m366kmshe"> · {sourceLabel}</span>}
      </span>
    </p>;
}